export type TopBarTranslation = {
  feedbackButton: {
    dialog: {
      button: {
        cancel: string;
        close: string;
        send: string;
      };
      content1: string;
      content2: string;
      description: string;
      error: string;
      subject: string;
      thanks: string;
      title: string;
    };
    label: string;
  };
  mailboxSync: {
    label: string;
    tooltip: string;
  };
  tooltip: {
    logout: string;
    profile: string;
  };
  welcome: string;
};

export const topBarTranslation: TopBarTranslation = {
  feedbackButton: {
    dialog: {
      button: {
        cancel: 'Anuluj',
        close: 'Zamknij',
        send: 'Wyślij',
      },
      content1: 'Zachęcamy do podzielenia się swoimi uwagami',
      content2:
        'W przypadku zgłaszania błędu prosimy o możliwie szczegółowy opis problemu oraz podanie daty i czasu jego wystąpienia.',
      description: 'Opis',
      error: 'Wprowadź co najmniej 3 znaki',
      subject: 'Temat',
      thanks: 'Dziękujemy za opinię!',
      title: 'Zgłoś błąd',
    },
    label: 'Zgłoś błąd',
  },
  mailboxSync: {
    label: 'Synchronizacja poczty…',
    tooltip:
      'Pobieramy zmiany ze skrzynki pocztowej. W tym czasie możesz normalnie korzystać z aplikacji.',
  },
  tooltip: {
    logout: 'Wyloguj',
    profile: 'Ustawienia',
  },
  welcome: 'Witaj',
};
